import * as actions from './actions';
import * as reducers from './reducers';
import sagas from './sagas';

export { default as ComponentsRoute } from './ComponentsRoute';

export default {
	actions,
	reducers,
	sagas
};
